// src/components/files/FileSearchBar.jsx
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { InputGroup, FormControl } from 'react-bootstrap';

const FileSearchBar = ({ searchQuery, setSearchQuery }) => {
  const [localQuery, setLocalQuery] = useState(searchQuery);
  const searchTimeout = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    setLocalQuery(searchQuery);
  }, [searchQuery]);

  useEffect(() => {
    return () => {
      if (searchTimeout.current) {
        clearTimeout(searchTimeout.current);
      }
    };
  }, []);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setLocalQuery(value);

    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }

    searchTimeout.current = setTimeout(() => {
      setSearchQuery(value);
    }, 300);
  };

  const handleClear = () => {
    setLocalQuery('');
    setSearchQuery('');

    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  return (
    <InputGroup className="search-bar" style={{ maxWidth: '300px' }}>
      <InputGroup.Text>
        <i className="fas fa-search"></i>
      </InputGroup.Text>

      <FormControl
      className='search-input-files'
        ref={inputRef}
        placeholder="Search files..."
        value={localQuery}
        onChange={handleInputChange}
      />

      {localQuery && (
        <InputGroup.Text
          className="search-clear-btn"
          onClick={handleClear}
          style={{ cursor: 'pointer' }}
        >
          <i className="fas fa-times"></i>
        </InputGroup.Text>
      )}
    </InputGroup>
  );
};

FileSearchBar.propTypes = {
  searchQuery: PropTypes.string.isRequired,
  setSearchQuery: PropTypes.func.isRequired
};

export default FileSearchBar;